import React from 'react'

var d = new Date();
var currYear = d.getFullYear();
export const Footer = (props) => {

    return (
        <footer className="footer-style2-area" id='footer'>
            {/* <!--Start Footer--> */}
            <div className="footer-style2">
                <div className="auto-container">
                    <div className="outer-box">

                        <div className="row">

                            <div className="col-xl-12">
                                <div className="order-box">
                                    <div className="title-holder">
                                        <div className="icon">
                                            <div className="icon-bg" style={{ backgroundImage: " url(img/save-water.png)", height: '64px', width: '64px' }}></div>
                                            <span className="icon-water-1"></span>
                                        </div>

                                        <div className="text">
                                            <h2>Service Areas :-</h2>
                                            <p> Delhi, Noida, Ghaziabad, Gurugram, Faridabad</p>
                                        </div>
                                    </div>
                                    <div className="btn-box">
                                        <a className="btn-one" href="tel:18008917531" style={{ fontSize: '24px', marginTop: '20px' }}>
                                            <div className="round"></div>
                                            <span className="txt">Call: 18008917531</span>
                                        </a>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* <!--End Footer--> */}

            <div className="footer-bottom footer-bottom--style2">
                <div className="container">
                    <div className="bottom-inner clearfix">
                        {/* <!--<div className="copyright pull-right">
                        <p>Copyright &copy; <a href="index.html"> 2026 RO Service Center.</a> All Rights Reserved.</p>
                        </div>--> */}
                        <ul className="footer-nav pull-left clearfix">
                            <li>Quick Links:</li>
                            <li><a href="/">Home</a></li>
                            <li><a href="#about">About</a></li>
                            <li><a href="#services">Services</a></li>
                            <li><a href="tel:18008917531"><b>Toll Free Customer Care</b></a></li>
                            <li><a href="/privacy-policy">Privacy Policy</a></li>
                        </ul>
                    </div>
                    <p style={{ color: '#989793', marginTop: '10px', fontSize: '13px' }}><b>Disclaimer-</b> This is an independent Service centre. We are the Largest &amp; Fastest Growing Service Provider &amp; We undertake job work of Service, AMC, Repair &amp; Maintenance of RO Service &amp; repair, we are totally responsible for these and No relation to any company in any regards.</p>
                </div>

            </div>

        </footer>
    )
}

